import { SvgIcon } from '../svg-icon/index.js';
import { jsx } from 'react/jsx-runtime';

function Icon(_ref) {
  let {
    svgIcon,
    transform,
    color,
    block,
    alt,
    nonStandardSizeOverride,
    className,
    ...props
  } = _ref;
  return svgIcon ? /*#__PURE__*/jsx(SvgIcon, {
    ...props,
    className: className,
    icon: svgIcon,
    transform: transform,
    color: color,
    block: block,
    alt: alt,
    nonStandardSizeOverride: nonStandardSizeOverride
  }) : null;
}

export { Icon };
//# sourceMappingURL=index.js.map
